(function () {

	Vue.component('nominow-functionblock', {
		model: {
			prop: 'functionblock',
			event: 'change'
		},
		props: {
			functionblock: {
				type: Array,
				default: () => []
			},
			blocks: {
				type: Array,
				required: true
			}
		},
		data: function () {
			return {
				name: null,
				block: {},
				config: null,
				servicedescription: null,
				activefunction: null,
				error: null
			};
		},
		created: function () {
			var self = this;
			if (this.functionblock) {
				this.name = this.functionblock[0];
				this.block = this.functionblock[1];
				this.config = this.blocks.find((item) => item.Name == this.name);

				if (this.config && this.config.ServiceAddress) {
					var host = this.config.ServiceAddress;
					GET('/auth/serviceinfo?serviceType=restplugin&host=' + host).then(function (xhr) {
						var result = JSON.parse(xhr.responseText);
						self.servicedescription = result.SingleResult.Result.PluginClassNames.find((item) => item.ClassName == self.block.FunctionProperties.ServiceTypeName);
						if (self.servicedescription) {
							vuelog(self.servicedescription)
							self.activefunction = self.servicedescription.ServiceFunctions.find((item) => item.MethodName == self.block.FunctionProperties.ServiceMethod)
						}
					}, function (xhr) {
						console.log('error', xhr, xhr.responseText)
						self.error = xhr.responseText;
					});
				}
			}
		},
		methods: {
			updateActiveFunction: function () {
				this.activefunction = this.servicedescription.ServiceFunctions.find((item) => item.MethodName == this.block.FunctionProperties.ServiceMethod)
				if (this.activefunction) {
					this.block.FunctionProperties.FunctionParameters = this.activefunction.InputParameters;
					this.emitChange();
				}
			},
			formatParams: function (obj) {
				var str = JSON.stringify(obj);
				str = str.replace(/[{}\"]/gi, "").replace(/,/g, ", ").replace(/:/g, ": ");
				return str;
			},
			emitChange: function () {
				this.$emit('change', [this.name, this.block]);
			}
		},
		template: `
	<div>
		<div class=" field ">
			{{name}}
		</div>
		<div v-if="servicedescription && servicedescription.ServiceFunctions">
			<div class=" field select is-light">
				<select v-model="block.FunctionProperties.ServiceMethod" v-on:change="updateActiveFunction">
					<option v-for="(o,i) in servicedescription.ServiceFunctions" v-bind:value="o.MethodName">{{o.MethodName}}({{formatParams(o.InputParameters)}})</option>
				</select>
			</div>
			<table class="table is-striped  is-fullwidth">
				<thead>
					<tr>
					<th>Key</th> <th width="60%">Value</th>
					</tr>
				</thead>
				<tbody>
					<tr class="field" v-for="(m,k,i) in servicedescription.ServiceConfig">
						<td>{{k}}</td>
						<td>
							<input type="text" class="input" v-bind:data-id="k" name="pluginSetting" v-model="block.FunctionProperties.ServiceConfig[k]" v-on:change="emitChange"/>
						</td>
					</tr>
				</tbody>
			</table>
			<br/>
			<nominow-input-checkbox v-model="block.ReturnAfterThis" label="Return after this"></nominow-input-checkbox>
		</div>
		<div v-else>
			<div v-if="error">
			Trying to load service description from {{config}}<br/>
			{{error}}
			</div>
		</div>
	</div>
	`,
	});
})();
